export default __webpack_public_path__ + "static/media/smiling-2362136_1920.43f65afb.jpg";